import axios from '@/axios.js'

export default {
  fetchPromoRatePlans ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`vancynet/promo-rate-plan`)
        .then(({data: response}) => {
          commit('SET_PROMO_RATE_PLANS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchPromoRatePlan (context, promoRatePlanId) {
    return new Promise((resolve, reject) => {
      axios.get(`vancynet/promo-rate-plan/${promoRatePlanId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  storePromoRatePlan (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`vancynet/promo-rate-plan`, payload)
           .then(res => {
             resolve(res)
           })
           .catch(err => {
             reject(err)
           })
    })
  },

  updatePromoRatePlan (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`vancynet/promo-rate-plan/${payload.id}`, payload.body)
           .then(res => {
             resolve(res)
           })
           .catch(err => {
             reject(err)
           })
    })
  },

  destroyPromoRatePlan ({ commit }, promoRatePlanId) {
    return new Promise((resolve, reject) => {
      axios.delete(`vancynet/promo-rate-plan/${promoRatePlanId}`)
        .then((response) => {
          commit('REMOVE_RECORD', promoRatePlanId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
